export enum MaintenanceBookletOptionType {
  Yes = 'yes',
  No = 'no',
  MaintainedFollowingServiceSchedules = 'maintained_following_service_schedules'
}
